<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const { availableVehicles } = useFleequidStats();
</script>

<template>
    <div class="bg-primary sticky inset-x-0 top-0 z-40 flex h-(--announcement-bar-height) items-center text-xs font-medium text-white">
        <!-- Desktop -->
        <BaseWidthContainer class="hidden w-full items-center justify-between lg:flex">
            <div class="flex items-center gap-3">
                <span>{{ tt('announcementBar.vehiclesInspected', { count: availableVehicles }) }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.securePayments') }}</span>
                <span class="text-white/50">·</span>
                <span>{{ tt('announcementBar.endToEndService') }}</span>
            </div>
            <span>
                {{ tt('announcementBar.callForAdvice') }}
                <FleequidPhoneLink class="text-white" />
            </span>
        </BaseWidthContainer>

        <!-- Mobile: marquee -->
        <UMarquee :overlay="false" class="lg:hidden" :ui="{ root: '[--gap:--spacing(4)]' }">
            <span>{{ tt('announcementBar.vehiclesInspected', { count: availableVehicles }) }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.securePayments') }}</span>
            <span class="text-white/50">·</span>
            <span>{{ tt('announcementBar.endToEndService') }}</span>
            <span class="text-white/50">·</span>
            <span>
                {{ tt('announcementBar.callForAdvice') }}
                <FleequidPhoneLink class="text-white" />
            </span>
            <span class="text-white/50">·</span>
        </UMarquee>
    </div>
</template>
